import { render } from "./SidebarView.vue?vue&type=template&id=07530aec&scoped=true"
import script from "./SidebarView.vue?vue&type=script&lang=js"
export * from "./SidebarView.vue?vue&type=script&lang=js"

import "./SidebarView.vue?vue&type=style&index=0&id=07530aec&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07530aec"]])

export default __exports__